<div
  class="asic-status-tag"
  [class]="AsicStatus[status ?? AsicStatus.NotLodged]"
>
  <span>{{ status | asicStatus }}</span>
</div>
